import { Box, Typography, Grid, Tooltip } from "@mui/material";
import React from "react";
import CustomerSentimentDashboard from "./CustomerSentiment";
import CustomerExperienceUI from "./CustomerAnalytics";
import KeywordsThemes from "./KeywordsThemes";
import CustomerMetrics from "./CustomerMetrics";
import InfoIcon from "@mui/icons-material/Info";

const CustomerAnalysis = ({ customerAnalytics, overview }) => {
  console?.log(customerAnalytics, "dd");
  return (
    <>
      <Box>
        <Typography
          variant="h5"
          component="h1"
          fontWeight="bold"
          sx={{ display: "flex", alignItems: "center", gap: 1 }}
        >
          Customer Analysis
          <Tooltip
            title="It gives the basic details of the customer like the name, photo and sentimental score"
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <InfoIcon
              sx={{
                fontSize: 18,
                color: "grey",
              }}
            />
          </Tooltip>
        </Typography>

        <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
          In-depth analysis of customer sentiment, intent, and experience during
          this conversation.
        </Typography>
      </Box>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <CustomerSentimentDashboard
            customerAnalytics={customerAnalytics}
            overview={overview}
          />
        </Grid>

        <Grid item xs={12}>
          <CustomerExperienceUI customerAnalytics={customerAnalytics} />
        </Grid>
      </Grid>
    </>
  );
};

export default CustomerAnalysis;
